module.exports = __webpack_public_path__ + "img/3.f7797170.png";